export function getSafeHttpUrlHref(value: string): string | undefined {
  try {
    const parsed = new URL(value);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return undefined;
    }
    return parsed.href;
  } catch {
    return undefined;
  }
}

export function isSafeHttpUrl(value: string): boolean {
  return getSafeHttpUrlHref(value) !== undefined;
}
